import React from "react";

export const DashboardAsideButtonMobile = ({
  insideText,
  svg,
  margin,
  eventKey,
}) => {
  return (
    <button
      style={{
        cursor: "pointer",
        background: "transparent",
        width: "100%",
        height: "13.15vw",
        padding: "3.29vw 6.58vw",
        borderRadius: "2.19vw",
        WebkitUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
        margin: margin,
        border: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "10px",
          filter: "opacity(0.4)",
        }}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      <span
        style={{
          color: "#2E2E2E",
        }}
      >
        {insideText}
      </span>
    </button>
  );
};
